import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 'S', label: 'Transferred to another school in New Zealand' },
    { value: 'H', label: 'Transferring to home-schooling' },
    { value: 'O', label: 'Gone Overseas' },
    { value: 'D', label: 'Deceased' },
    { value: 'X', label: 'Expulsion' },
    { value: 'L', label: 'End of Schooling' },
    {
      value: 'E',
      label: 'Granted Early Exemption (applies to those <16yrs old)',
    },
    { value: 'K', label: 'Exclusion (applies to those <16yrs old)' },
    { value: 'C', label: 'Continuous Absence' },
    { value: 'J', label: 'Eligibility Expired' },
    { value: 'P', label: 'Caregiver Decision' },
  ],
});
